/// <reference path="../../../../typings/index.d.ts" />
angular.module('app').factory('ServerLogsServiceApi', ($http, ApiErrorService) => {
    return {
        getFileList: getFileList,
        getAllFilesInZip: getAllFilesInZip,
        downloadFile: downloadFile,
        truncateFile: truncateFile,
        deleteFile: deleteFile,
        getSimulatorInstanceFileList: getSimulatorInstanceFileList,
        getSimulatorInstanceAllFilesInZip: getSimulatorInstanceAllFilesInZip,
        getSimulatorFileList: getSimulatorFileList,
        getSimulatorAllFilesInZip: getSimulatorAllFilesInZip
    };
    function getFileList(serverControllerId) {
        return $http.get(`api/ServerLogs/${serverControllerId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function getAllFilesInZip(serverControllerId) {
        return $http.get(`api/ServerLogs/${serverControllerId}/Zip`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function downloadFile(serverControllerId, fileName) {
        return $http.get(`api/ServerLogs/${serverControllerId}/${encodeURIComponent(fileName)}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function truncateFile(serverControllerId, fileName, kilobyteSize) {
        return $http.post(`api/ServerLogs/${serverControllerId}/${encodeURIComponent(fileName)}/Truncate?kilobyteSize=${kilobyteSize}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function deleteFile(serverControllerId, fileName) {
        return $http.post(`api/ServerLogs/${serverControllerId}/${encodeURIComponent(fileName)}/Delete`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function getSimulatorInstanceFileList(simInstanceId) {
        return $http.get(`api/ServerLogs/SimInstances/${simInstanceId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function getSimulatorInstanceAllFilesInZip(simInstanceId) {
        return $http.get(`api/ServerLogs/SimInstances/${simInstanceId}/Zip`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function getSimulatorFileList(simId) {
        return $http.get(`api/ServerLogs/Simulator/${simId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function getSimulatorAllFilesInZip(simId) {
        return $http.get(`api/ServerLogs/Simulator/${simId}/Zip`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
});
